/** Normaliza un teléfono colombiano a E.164. "300 123 4567" → "+573001234567". */
export function normalizeColombianPhone(raw) {
    const clean = raw.replace(/[\s+\-().]/g, '');
    const normalized = /^\d{10}$/.test(clean) && clean.startsWith('3') ? `57${clean}` : clean;
    return `+${normalized}`;
}
//# sourceMappingURL=phone.js.map